export const waitUntil = async (
  conditionFunc: () => boolean,
  intervalTime = 250,
  timeout = 5000,
  error = 'Operation timed out'
): Promise<void> => {
  return new Promise((resolve, reject) => {
    let isResolved = false;

    // Single timeout for the entire operation
    const timeoutId = setTimeout(() => {
      if (!isResolved) {
        isResolved = true;
        reject(new Error(error));
      }
    }, timeout);

    const check = () => {
      if (isResolved) return;

      try {
        if (conditionFunc()) {
          isResolved = true;
          clearTimeout(timeoutId);
          resolve();
        } else {
          setTimeout(check, intervalTime);
        }
      } catch (err) {
        isResolved = true;
        clearTimeout(timeoutId);
        reject(err);
      }
    };

    check();
  });
};
